import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Web3Provider } from './context/Web3Context';
import Header from './components/Layout/Header';
import Sidebar from './components/Layout/Sidebar';
import Footer from './components/Layout/Footer';
import ToastContainer from './components/Notification/Toast';

import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Invest from './pages/Invest';
import MyInvestments from './pages/MyInvestments';
import Rewards from './pages/Rewards';
import Team from './pages/Team';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';

import './styles/theme.css';
import './styles/global.css';
import './styles/animations.css';
import './styles/components.css';
import './styles/forms.css';
import './styles/layout.css';
import './styles/dashboard.css';
import './styles/invest.css';
import './styles/team.css';
import './styles/notification.css';
import './styles/success.css';
import './styles/responsive.css';

const AppShell = () => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const isLanding = location.pathname === '/';

  if (isLanding) {
    return (
      <>
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main style={{ marginTop: 'var(--header-height)', position: 'relative', zIndex: 1 }}>
          <Home />
        </main>
        <ToastContainer />
      </>
    );
  }

  return (
    <>
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      <div className="app-shell">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="main">
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/invest" element={<Invest />} />
            <Route path="/my-investments" element={<MyInvestments />} />
            <Route path="/rewards" element={<Rewards />} />
            <Route path="/team" element={<Team />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
          <Footer />
        </main>
      </div>
      <ToastContainer />
    </>
  );
};

const App = () => {
  return (
    <Web3Provider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="*" element={<AppShell />} />
        </Routes>
      </BrowserRouter>
    </Web3Provider>
  );
};

export default App;
